const locale = {
  locationLayerPlaceholder: '签名区域',
  loadingError: 'PDF尚未加载成功，请稍后重试',
  signatureDefaultTitle: '签名',
  signatureConfirmText: '确认',
  signatureCancelText: '取消',
  signatureCleanText: '清空',
  signatureEmptyError: '签名内容不能为空',
  signatureSuccess: '签名成功',
  signatureAdd: '请添加签名'
};

export default locale;
